// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1G6Wy","footerText":"Footer_footerText__2N2GZ"};